import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense, startTransition } from "react";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home"; // Keep Home as immediate import for fastest loading

// Lazy load all other page components
const Services = lazy(() => import("./pages/Services"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const HealthPackages = lazy(() => import("./pages/HealthPackages"));
const HealthPackageDetail = lazy(() => import("./pages/HealthPackageDetail"));
const Endoscopy = lazy(() => import("./pages/Endoscopy"));
const Gallery = lazy(() => import("./pages/Gallery"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Blogs = lazy(() => import("./pages/Blogs"));
const Contact = lazy(() => import("./pages/Contact"));
const Expertise = lazy(() => import("./pages/Expertise"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-3 border-b-3 border-green-600 mx-auto"></div>
      <p className="mt-4 text-gray-600 font-medium">Loading page...</p>
    </div>
  </div>
);

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={
            <Suspense fallback={<LoadingFallback />}>
              <Services />
            </Suspense>
          } />
          <Route path="/services/:serviceId" element={
            <Suspense fallback={<LoadingFallback />}>
              <ServiceDetail />
            </Suspense>
          } />
          <Route path="/health-packages" element={
            <Suspense fallback={<LoadingFallback />}>
              <HealthPackages />
            </Suspense>
          } />
          <Route path="/health-packages/:packageId" element={
            <Suspense fallback={<LoadingFallback />}>
              <HealthPackageDetail />
            </Suspense>
          } />
          <Route path="/endoscopy" element={
            <Suspense fallback={<LoadingFallback />}>
              <Endoscopy />
            </Suspense>
          } />
          <Route path="/gallery" element={
            <Suspense fallback={<LoadingFallback />}>
              <Gallery />
            </Suspense>
          } />
          <Route path="/about" element={
            <Suspense fallback={<LoadingFallback />}>
              <AboutUs />
            </Suspense>
          } />
          <Route path="/blogs" element={
            <Suspense fallback={<LoadingFallback />}>
              <Blogs />
            </Suspense>
          } />
          <Route path="/contact" element={
            <Suspense fallback={<LoadingFallback />}>
              <Contact />
            </Suspense>
          } />
          <Route path="/expertise" element={
            <Suspense fallback={<LoadingFallback />}>
              <Expertise />
            </Suspense>
          } />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;